export default {
      id: "ic_empty_transactions-usage",
      viewBox: "0 0 163 163",
      url: "/" + "images/icons.3.109.2.svg#ic_empty_transactions-usage",
      toString: function () {
        return this.url;
      }
    }